import React from "react";

export default function UserLoggedInIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1.6rem">
      <g
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        id="user-logged-in"
      >
        <path
          fillRule="evenodd"
          d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12S0 18.623 0 12 5.377 0 12 0m7.606 18.49-.516-4.59h.02c-.06-.51-.49-.9-1-.9h-3.1c0 1.66-1.34 3-3 3s-3-1.34-3-3h-3.1a1 1 0 0 0-1 .9l-.516 4.59A9.96 9.96 0 0 1 2 12C2 6.48 6.48 2 12 2s10 4.48 10 10a9.96 9.96 0 0 1-2.394 6.49M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
}
